import { CardMedia, Stack, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import img1 from "./CWTA.webp";
import img2 from "./Flow.png";
import img3 from "./Payment.webp";
import img4 from "./Template.webp";
import { MdLeaderboard } from "react-icons/md";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { MdBorderInner } from "react-icons/md";
import { SiLimesurvey } from "react-icons/si";

const WhyWhatApp = ({ data, index }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const cardData1 = [
    {
      card_title: "Event Registration 1",
      card_description:
        "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
      card_img: img1,
      card_background: "#e1efff",
    },
    {
      card_title: "Event Registration 2",
      card_description:
        "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
      card_img: img2,
      card_background: "#EAFBF1",
    },
    {
      card_title: "Event Registration 3",
      card_description:
        "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
      card_img: img3,
      card_background: "#e2e9f0",
    },
    {
      card_title: "Event Registration 4",
      card_description:
        "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
      card_img: img4,
      card_background: "#e3e9ff",
    },
  ];

  const [cardData, setCardData] = useState(cardData1);

  useEffect(() => {
    setCardData(data[index]?.marketing);
  }, [data]);
  const tabData = [
    { icon: <MdLeaderboard />, title: "Lead Qualification" },
    { icon: <MdOutlineMiscellaneousServices />, title: "Service Booking" },
    { icon: <MdBorderInner />, title: "Order Tracking" },
    { icon: <SiLimesurvey />, title: "Surveys & Feedback" },
  ];

  const [selectedIndex, setSelectedIndex] = useState(0); // default 0

  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleSwipe = () => {
    if (touchStartX.current - touchEndX.current > 50 && selectedIndex < 3) {
      setSelectedIndex((prev) => prev + 1);
    } else if (
      touchEndX.current - touchStartX.current > 50 &&
      selectedIndex > 0
    ) {
      setSelectedIndex((prev) => prev - 1);
    }
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const selectedCard = cardData[selectedIndex];

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: { xs: "70vh", sm: "70vh" },
        marginTop: { xs: "8px", sm: "80px" },
        // border: "1px solid red",
        borderRadius: { xs: "8px", sm: "0px" },
      }}
    >
      <Stack
        sx={{
          //   width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Navigation Buttons */}
        <Stack
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            gap: { xs: 2, sm: 5 },
            height: { xs: "4%", sm: "6%" },
            justifyContent: "center",
          }}
        >
          {tabData.map((tab, index) => (
            <Stack
              key={index}
              sx={{
                width: "20%",
                border: "1px solid #ddd",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor:
                  selectedIndex === index ? "rgb(5, 78, 146)" : "#f0f9ff",
                fontWeight: selectedIndex === index ? 600 : 400,
              }}
              onClick={() => setSelectedIndex(index)}
            >
              {/* {index + 1} */}
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 1,
                  color: selectedIndex === index ? "white" : "black",
                }}
              >
                <Stack>{tab.icon}</Stack>
                <Stack>{tab.title}</Stack>
              </Stack>
            </Stack>
          ))}
        </Stack>

        {/* Content Section */}

        <Stack
          onTouchStart={isMobile ? handleTouchStart : null}
          onTouchMove={isMobile ? handleTouchMove : null}
          onTouchEnd={isMobile ? handleSwipe : null}
          sx={{
            height: { xs: "100%", sm: "94%" },
            width: "100%",
            // border: "1px solid #d7ecfa",
            borderRadius: "8px",
            // backgroundColor: "#d7ecfa",
            backgroundColor: {
              xs: selectedCard.card_background,
              sm: "#d7ecfa",
            },
            // border: "1px solid red",
          }}
        >
          <Stack
            sx={{
              height: { xs: "100%", sm: "100%" },
              width: "100%",
              // border: "1px solid #d7ecfa",
              backgroundColor: {
                xs: selectedCard.card_background,
                sm: "#d7ecfa",
              },
              borderRadius: { xs: "8px", sm: "0px" },
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
                height: "100%",
                width: "100%",
                padding: { xl: 4, lg: 4, md: 3, sm: 3, xs: 0 },
                borderRadius: { xs: "8px", sm: "0px" },
              }}
            >
              <Stack
                // sx={{
                //   height: {
                //     xl: "100%",
                //     lg: "100%",
                //     md: "100%",
                //     sm: "100%",
                //     xs: "70%",
                //   },
                //   width: {
                //     xl: "45%",
                //     lg: "45%",
                //     md: "45%",
                //     sm: "45%",
                //     xs: "100%",
                //   },
                //   border: { xs: "1px solid blue", sm: "none" },
                //   marginTop: { xs: "0px", sm: "16px" },
                //   display: { xs: "flex", sm: "none" },
                //   borderRadius: { xs: "8px", sm: "0px" },
                // }}

                sx={{
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "70%",
                  },
                  width: {
                    xl: "45%",
                    lg: "45%",
                    md: "45%",
                    sm: "45%",
                    xs: "100%",
                  },
                  display: { xs: "flex", sm: "none" },
                  marginTop: { xs: "0px", sm: "16px" },
                  // borderRadius: { xs: "12px", sm: "0px" },
                  overflow: "hidden",
                  position: "relative",

                  // Glassmorphism only for xs
                  backgroundColor: {
                    xs: "rgba(255, 255, 255, 0.1)",
                  },
                  backdropFilter: {
                    xs: "blur(10px)",
                  },
                  WebkitBackdropFilter: {
                    xs: "blur(10px)",
                  },
                  border: {
                    xs: "1px solid rgba(255, 255, 255, 0.2)",
                  },
                  boxShadow: {
                    xs: "0 4px 30px rgba(0, 0, 0, 0.1)",
                  },

                  // Shimmer effect
                  "&::after": {
                    content: '""',
                    display: { xs: "block", sm: "none" },
                    position: "absolute",
                    top: 0,
                    left: "-150%",
                    width: "150%",
                    height: "100%",
                    background:
                      "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
                    animation: "shineXs 2s infinite",
                  },

                  // Keyframes for xs only
                  "@keyframes shineXs": {
                    "0%": { left: "-150%" },
                    "50%": { left: "100%" },
                    "100%": { left: "150%" },
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={selectedCard.card_img}
                  alt={selectedCard.card_title}
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: 2,
                    objectFit: "contain",
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "30%",
                  },
                  width: {
                    xl: "55%",
                    lg: "55%",
                    md: "55%",
                    sm: "55%",
                    xs: "100%",
                  },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: {
                    xl: "center",
                    lg: "center",
                    md: "center",
                    sm: "center",
                    xs: "flex-start",
                  },
                  // border: "2px solid red",
                  // alignItems: "center",
                  alignItems: {
                    xl: "center",
                    lg: "center",
                    md: "center",
                    sm: "center",
                    xs: "flex-start", // 👈 Add this line
                  },
                  gap: { xs: 0, sm: 2 },
                }}
              >
                <Stack
                  sx={{
                    fontSize: {
                      xl: "40px",
                      lg: "40px",
                      md: "32px",
                      sm: "32px",
                      xs: "20px",
                    },
                    fontWeight: 600,
                    lineHeight: {
                      xl: "44px",
                      lg: "44px",
                      md: "36px",
                      sm: "36px",
                      xs: "32px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    textAlign: "left",
                    display: { xs: "none", sm: "flex" },
                  }}
                >
                  {selectedCard.card_title}
                </Stack>

                <Stack
                  sx={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: {
                      xs: "20px",
                      sm: "30px",
                      md: "28px",
                      lg: "48px",
                      xl: "48px",
                    },
                    lineHeight: {
                      xs: "28px",
                      sm: "36px",
                      md: "32px",
                      lg: "52px",
                      xl: "52px",
                    },
                    fontWeight: 600,
                    color: "rgb(5 78 146)",
                    textAlign: "center",
                    marginBottom: {
                      xs: "20px",
                      sm: "20px",
                      md: "20px",
                      lg: "20px",
                      xl: "20px",
                    },
                    marginTop: {
                      xs: "20px",
                      sm: "20px",
                      md: "40px",
                      lg: "64px",
                      xl: "64px",
                    },
                    // border: "1px solid red",
                    display: { xs: "flex", sm: "none" },
                    flexDirection: "row",
                    marginLeft: { xs: "8px", sm: "0px" },
                  }}
                >
                  <Stack
                    sx={{
                      // border: "1px solid red",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      sx={{
                        width: { xl: "6px", lg: "6px", xs: "4px" },
                        // height: { xl: "100%", lg: "100%", xs: "100%" },
                        height: {
                          xs: "20px",
                          sm: "44px",
                          md: "28px",
                          lg: "40px",
                          xl: "40px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "1px solid rgb(5 78 146)",
                        // backgroundColor: "rgb(5 78 146)",
                        backgroundColor: "rgb(5 78 146)",
                        marginRight: {
                          xs: "8px",
                          sm: "8px",
                          md: "12px",
                          lg: "12px",
                          xl: "12px",
                        },
                        borderTopRightRadius: "8px", // Adjust the value as needed
                        borderBottomRightRadius: "8px", // Adjust the value as needed
                      }}
                    >
                      <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                    </Stack>
                  </Stack>
                  <span
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    {selectedCard.card_title}
                  </span>
                </Stack>
                <Stack
                  sx={{
                    fontSize: {
                      xl: "28px",
                      lg: "28px",
                      md: "20px",
                      sm: "20px",
                      xs: "16px",
                    },
                    fontWeight: 400,
                    lineHeight: {
                      xl: "32px",
                      lg: "32px",
                      md: "24px",
                      sm: "24px",
                      xs: "20px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    textAlign: "left",
                    marginLeft: { xs: "8px", sm: "0px" },
                    color: "#333",
                    width: "96%",
                  }}
                >
                  {selectedCard.card_description}
                </Stack>
              </Stack>
              {/* <Stack
                sx={{
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "50%",
                  },
                  width: {
                    xl: "45%",
                    lg: "45%",
                    md: "45%",
                    sm: "45%",
                    xs: "100%",
                  },
                  border: "1px solid green",
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <CardMedia
                  component="img"
                  image={selectedCard.card_img}
                  alt={selectedCard.card_title}
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: 2,
                    objectFit: "contain",
                  }}
                />
              </Stack> */}
              <Stack
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "50%",
                  },
                  width: {
                    xl: "45%",
                    lg: "45%",
                    md: "45%",
                    sm: "45%",
                    xs: "100%",
                  },
                  display: { xs: "none", sm: "flex" },
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "12px",
                  background: "rgba(255, 255, 255, 0.1)",
                  backgroundColor: "#eaf6ff",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  //   border: "2px solid blue",
                  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",

                  // 🔥 Shimmer effect
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "-150%",
                    height: "100%",
                    width: "150%",
                    background:
                      "linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)",
                    animation: "shine 2s infinite",
                  },

                  // Keyframe inside sx using @keyframes
                  "@keyframes shine": {
                    "0%": { left: "-150%" },
                    "50%": { left: "100%" },
                    "100%": { left: "150%" },
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={selectedCard.card_img}
                  alt={selectedCard.card_title}
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: 2,
                    objectFit: "contain",
                    borderRadius: "12px",
                    zIndex: 1,
                    // border: "2px solid red",
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default WhyWhatApp;
